// Minimal CSV parser: quoted fields, commas, CRLF, UTF-8 BOM.
export function parseCsv(text) {
  const input = String(text || '').replace(/^\uFEFF/, '');
  const rows = [];
  let row = [];
  let cell = '';
  let inQuotes = false;

  for (let i = 0; i < input.length; i++) {
    const c = input[i];
    if (inQuotes) {
      if (c === '"') {
        if (input[i + 1] === '"') {
          cell += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cell += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ',') {
      row.push(cell);
      cell = '';
    } else if (c === '\n') {
      row.push(cell);
      rows.push(row);
      row = [];
      cell = '';
    } else if (c !== '\r') {
      cell += c;
    }
  }
  if (cell.length || row.length) {
    row.push(cell);
    rows.push(row);
  }

  if (!rows.length) return { headers: [], records: [] };

  const headers = rows[0].map((h) => String(h || '').trim()).filter((h, i, arr) => h || arr.some((x) => x));
  const uniqueHeaders = [];
  const seen = {};
  headers.forEach((h) => {
    const base = h || 'Column';
    let name = base;
    if (seen[name]) {
      seen[name] += 1;
      name = `${base} ${seen[name]}`;
    } else {
      seen[name] = 1;
    }
    uniqueHeaders.push(name);
  });

  const records = rows
    .slice(1)
    .filter((r) => r.some((v) => String(v || '').trim() !== ''))
    .map((r) => {
      const obj = {};
      uniqueHeaders.forEach((h, i) => {
        obj[h] = String(r[i] || '').trim();
      });
      return obj;
    });

  return { headers: uniqueHeaders, records };
}

export function guessColumnId(header, columns) {
  const h = String(header || '').trim().toLowerCase();
  if (!h) return '';
  const exact = (columns || []).find((c) => c.name.toLowerCase() === h);
  if (exact) return exact.id;
  if (h === 'name' || h === 'full name' || h === 'fullname' || h === 'member' || h === 'member name') {
    const col = (columns || []).find((c) => c.name.toLowerCase() === 'name');
    if (col) return col.id;
  }
  if (h === 'email' || h === 'e-mail' || h === 'email address' || h.includes('email')) {
    const col = (columns || []).find((c) => c.name.toLowerCase() === 'email');
    if (col) return col.id;
  }
  return '__new__';
}
